export default "__VITE_ASSET__63226d79__"